import React from 'react'

export default props => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM11.2776 28.2482C10.8871 27.8577 10.8871 27.2245 11.2776 26.834L18.1422 19.9695L11.2787 13.1061C10.8882 12.7155 10.8882 12.0824 11.2787 11.6918C11.6693 11.3013 12.3024 11.3013 12.6929 11.6918L19.5564 18.5553L26.834 11.2777C27.2245 10.8871 27.8577 10.8871 28.2482 11.2777C28.6387 11.6682 28.6387 12.3014 28.2482 12.6919L20.9706 19.9695L28.2493 27.2482C28.6398 27.6387 28.6398 28.2719 28.2493 28.6624C27.8588 29.0529 27.2256 29.0529 26.8351 28.6624L19.5564 21.3837L12.6919 28.2482C12.3013 28.6388 11.6682 28.6388 11.2776 28.2482Z"
      fill="#DE2F4C"
    />
  </svg>
)
